import React from 'react';
import toast from 'react-hot-toast';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { useParameterizedQuery } from 'react-fetching-library';
import { downloadFeedCSVAction } from '../../../../services/request';


export const DownloadCSV = ({ rowData }) => {
  const { query } = useParameterizedQuery(downloadFeedCSVAction);
  const handleDownload = async () => {
    const { payload, error, loading } = await query(rowData.id);

    if (!error) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `Zasilenie TFG ${rowData.agreement} ${new Date().getMilliseconds()}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  return (<Tooltip title="Pobierz plik JSON">
    <IconButton
      color="primary"
      onClick={() => handleDownload()}
    >
      <DownloadIcon />
    </IconButton>
  </Tooltip>);
};
